var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "mood-light-modal",
      attrs: {
        title: `${_vm.title}心情灯`,
        width: 780,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            labelCol: { span: 5 },
            wrapperCol: { span: 18 },
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "设备ID", prop: "serialNo" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入设备ID" },
                model: {
                  value: _vm.form.serialNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "serialNo", $$v)
                  },
                  expression: "form.serialNo",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "设备编号", prop: "deviceId" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入设备编号" },
                model: {
                  value: _vm.form.deviceId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "deviceId", $$v)
                  },
                  expression: "form.deviceId",
                },
              }),
            ],
            1
          ),
          _c("a-form-model-item", { attrs: { label: "所属类型" } }, [
            _c(
              "div",
              { staticClass: "flex-between" },
              [
                _c("j-dict-select-tag", {
                  staticStyle: { width: "31%" },
                  attrs: {
                    placeholder: "请选择年级",
                    dictCode:
                      "school_grade,grade_name,id,0=delete_flag order by sort_order",
                    allowClear: "",
                  },
                  on: {
                    select: () => {
                      _vm.$set(_vm.form, "classId", "")
                      _vm.$set(_vm.form, "studentId", "")
                    },
                    clear: () => {
                      _vm.$set(_vm.form, "classId", "")
                      _vm.$set(_vm.form, "studentId", "")
                    },
                  },
                  model: {
                    value: _vm.form.gradeId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "gradeId", $$v)
                    },
                    expression: "form.gradeId",
                  },
                }),
                _c("j-dict-select-tag", {
                  staticStyle: { width: "31%" },
                  attrs: {
                    placeholder: "请选择班级",
                    dictCode:
                      "school_class,name,id,grade_id=" +
                      (!_vm.form.gradeId ? -1 : _vm.form.gradeId),
                    disabled: !_vm.form.gradeId,
                    isShowEmpty: false,
                  },
                  on: {
                    select: function ($event) {
                      return _vm.$set(_vm.form, "studentId", "")
                    },
                    clear: function ($event) {
                      return _vm.$set(_vm.form, "studentId", "")
                    },
                  },
                  model: {
                    value: _vm.form.classId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "classId", $$v)
                    },
                    expression: "form.classId",
                  },
                }),
                _c("j-dict-select-tag", {
                  staticClass: "search-space",
                  staticStyle: { width: "31%" },
                  attrs: {
                    placeholder: "请选择学生",
                    disabled: !_vm.form.classId,
                    dictCode:
                      "student_info,name,id,class_id=" +
                      (!_vm.form.classId ? -1 : _vm.form.classId),
                    async: true,
                  },
                  model: {
                    value: _vm.form.studentId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "studentId", $$v)
                    },
                    expression: "form.studentId",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("a-form-model-item", { attrs: { label: "颜色状态设置" } }, [
            _c(
              "div",
              { staticStyle: { "flex-wrap": "wrap" } },
              _vm._l(_vm.form.configList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "flex-align-center" },
                  [
                    _c("div", {
                      style: {
                        width: "18px",
                        height: "18px",
                        background: item.color,
                        borderRadius: "50%",
                      },
                    }),
                    _c("div", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(_vm._s(item.moodLamp)),
                    ]),
                    _c(
                      "color-picker",
                      {
                        on: { change: (color) => _vm.changeColor(color, item) },
                        model: {
                          value: item.color,
                          callback: function ($$v) {
                            _vm.$set(item, "color", $$v)
                          },
                          expression: "item.color",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "20px",
                              color: "#4a90e2",
                              cursor: "pointer",
                            },
                          },
                          [_vm._v("+自定义")]
                        ),
                      ]
                    ),
                    _c("div", { staticStyle: { margin: "0 15px" } }, [
                      _vm._v(_vm._s(_vm.descList[index])),
                    ]),
                    _c(
                      "a-input-group",
                      {
                        staticClass: "flex-align-center",
                        staticStyle: { flex: "1" },
                        attrs: { compact: "" },
                      },
                      [
                        _c("a-input-number", {
                          staticStyle: {
                            width: "100px",
                            "text-align": "center",
                          },
                          attrs: { placeholder: "最小值" },
                          model: {
                            value: item.minVal,
                            callback: function ($$v) {
                              _vm.$set(item, "minVal", $$v)
                            },
                            expression: "item.minVal",
                          },
                        }),
                        _c("a-input", {
                          staticStyle: {
                            width: "30px",
                            "border-left": "0",
                            "pointer-events": "none",
                            "background-color": "#fff",
                          },
                          attrs: { placeholder: "~", disabled: "" },
                        }),
                        _c("a-input-number", {
                          staticStyle: {
                            width: "100px",
                            "text-align": "center",
                            "border-left": "0",
                          },
                          attrs: { placeholder: "最大值" },
                          model: {
                            value: item.maxVal,
                            callback: function ($$v) {
                              _vm.$set(item, "maxVal", $$v)
                            },
                            expression: "item.maxVal",
                          },
                        }),
                        _c("span", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v("%"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _c(
            "a-form-model-item",
            { attrs: { label: "预警提醒周期设置", prop: "warnPeriod" } },
            [
              _c(
                "a-radio-group",
                {
                  model: {
                    value: _vm.form.warnPeriod,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "warnPeriod", $$v)
                    },
                    expression: "form.warnPeriod",
                  },
                },
                _vm._l(_vm.warnCycleSetList, function (item, index) {
                  return _c(
                    "a-radio",
                    { key: index, attrs: { value: item.value } },
                    [_vm._v("\n          " + _vm._s(item.label) + "\n        ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }